import React, { useEffect, useState } from "react";
import { Navigate } from "react-router-dom";
import { jwtDecode } from "jwt-decode";

const ProtectedRoute = ({ children }: { children: React.ReactNode }) => {
  const [isAuthenticated, setIsAuthenticated] = useState<boolean>(false);
  const [isLoading, setIsLoading] = useState<boolean>(true);

  // Función para obtener y validar el access token
  const getAccessToken = () => {
    return localStorage.getItem("access_token");
  };

  // Función para verificar si el token ha expirado
  const isTokenExpired = (token: string | null) => {
    if (!token) return true;
    const decoded: any = jwtDecode(token);
    const currentTime = Date.now() / 1000; // Obtener el tiempo actual en segundos
    return decoded.exp < currentTime;
  };

  useEffect(() => {
    const accessToken = getAccessToken();

    if (!accessToken) {
      setIsAuthenticated(false);
      setIsLoading(false);
      return;
    }

    // Si el access token ha expirado, eliminamos ambos tokens
    if (isTokenExpired(accessToken)) {
      localStorage.removeItem("access_token");
      localStorage.removeItem("refresh_token");
      alert("Su sesión ha expirado");
      setIsAuthenticated(false);
      location.reload();
    } else {
      setIsAuthenticated(true);
    }

    setIsLoading(false);
  }, []);

  if (isLoading) {
    return <div></div>;
  }

  if (!isAuthenticated) {
    return <Navigate to="/" replace />;
  }

  return <>{children}</>;
};

export default ProtectedRoute;
